// extracted by mini-css-extract-plugin
export default {"TenantsManagement":"TenantsManagement_TenantsManagement__+l7Ha"};